














































































































import { mapGetters } from 'vuex';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import { formatDate, formatTime } from '@/Shared/Filters';

export default mixins(LocationBasedMixin).extend({
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('appealModule', [
            'getSearchResults',
            'searchError',
            'searchInProgress',
            'searchParams'
        ])
    },
    methods: {
        formatDateTime(date: Date): string {
            return formatDate(date) + ' ' + formatTime(date);
        },
    },
});

